/**
 * Custom Error class representing a duplication error, typically used when an attempt is made to create an entity that already exists.
 */
export class DuplicateError extends Error {
    /** Static error code to identify the error type. */
    static ERROR = 'DuplicateError'
    /** Optional identifier of the entity involved in the duplication. */
    id?: string

    /**
     * Creates a new DuplicateError.
     *
     * @param {string} [id] - Optional identifier of the entity that is considered a duplicate.
     * @param {string} [type] - Optional type or category of the entity.
     * @param {string} [message] - Optional custom error message.
     */
    constructor(id?: string, type?: string, message?: string) {
        super(message)
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, new.target.prototype); // restore prototype chain

        this.name = DuplicateError.ERROR
        this.id = id
        this.stack = new Error().stack
        if (id && type) {
            this.message = `${type} with id: ${id} already exists`
        }
    }
}
